import { render, staticRenderFns } from "./MailSubscriptions.vue?vue&type=template&id=19ce77e1"
import script from "./MailSubscriptions.vue?vue&type=script&lang=js"
export * from "./MailSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports